import store from '../store/main';

export function sessionLocalStorage() {
  const sessionObject = localStorage.getItem('botSessionObject');

  if (!!sessionObject) {
    try {
      const sessionDate = JSON.parse(sessionObject);
      const now = new Date();
      const parsedDate = new Date(sessionDate.date);
 
      const parsedDateMinutes = (parsedDate.getHours()*60) + parsedDate.getMinutes()
      const nowMinutes =  (now.getHours()*60) + now.getMinutes()
      const dateDiffInMinutes = (nowMinutes - parsedDateMinutes);
      
      if (dateDiffInMinutes >= 10) {
        store.updateSessionId();
        setLocalStoregeSession(store.sessionId)
        return "reload";
      }
    } catch (error) {
      console.error('errr', error);
    }
  }
}


export function setLocalStoregeSession(sessionId){
  const updatedSessionObject = {
      sessionId: sessionId,
      date: new Date()
  };

  const stringified = JSON.stringify(updatedSessionObject)

  localStorage.setItem('botSessionObject', stringified)
}
